import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ThinkingContainerComponent = ({ label }) => {
  return (
    <Box sx={{minHeight:160}} className='d-flex flex-column justify-content-center align-items-center m-3'>
      <CircularProgress />
      {label && (
        <Typography variant='body2' color='textSecondary' sx={{ mt: 2 }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

ThinkingContainerComponent.propTypes = {
  label: PropTypes.string,
};

export default ThinkingContainerComponent;
